<template>
  <div>
    <van-sticky>
      <van-nav-bar
        :title="$route.query.coursename+'('+this.countStu+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />

      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入姓名或学号关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in students" :key="item.id">
          <van-cell :border="false" :label="item.sGender+' '+item.sNum" :title="item.sName" value="<--"/>
          <template slot="right">
            <van-button square type="danger" @click="delStuById(item.sNum,item.sName)" text="刪除"/>
            <van-button square type="primary" @click="stuInfo(item.sId,item.sName)" text="详细"/>
            <van-button square type="info" @click="score(item.sId,item.sName,item.sNum,item.sGender,item.exempt)"
                        text="成绩"/>
            <van-button square type="warning" @click="resetStuPwdById(item.sId,item.sName)"
                        text="重置"/>
          </template>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>

    <van-action-sheet v-model="showSheet" :title="sName">
      <div style="margin-top: 10px;margin-bottom: 50px;">
        <div v-if="this.selected">
          <div style="text-align: center">
            <van-cell :border="false" :title="'俱乐部运动等级'+'('+ranks+')'"/>
            <van-cell :border="false" :title="'运动总时长'+'('+getEtime(this.etime)+')'"/>

            <van-divider
              :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
              训练记录
            </van-divider>
          </div>
          <van-cell-group title="训练记录">
            <van-cell v-for="item in TrainRecord" :key="item.id" :title="item.vname+'场馆'"
                      :value="'训练时间'+item.etime+'分钟'" :label="item.time"/>
          </van-cell-group>
        </div>
        <h3 style="text-align: center" v-if="!this.selected">暂未选择俱乐部</h3>
      </div>
    </van-action-sheet>

    <van-action-sheet v-model="scoreShow" :title="sName">
      <div style="margin-top: 50px;margin-bottom: 50px">
        <van-cell title="姓名" :value="this.sName"/>
        <van-cell title="学号" :value="this.snum"/>
        <van-cell title="性别" :value="this.gender"/>
        <van-divider contentPosition="center">成绩</van-divider>


        <van-cell v-for="item in scores" :title="`${item.years} ${item.grade} ${item.term} `" :value="item.score" :id="item.id"/>
<!--        <van-form @submit="onSubmit">-->

<!--          <van-field v-show="this.$cookies.get('user') === 'admin'" name="exempt" label="是否免修">-->
<!--            <template #input>-->
<!--              <van-switch v-model="exempt" size="24"/>-->
<!--            </template>-->
<!--          </van-field>-->

<!--          <van-field name="score1" label="体测成绩">-->
<!--            <template #input>-->
<!--              <van-stepper theme="round" min="0" max="30" disabled integer v-model="score1"/>-->
<!--            </template>-->
<!--          </van-field>-->

<!--          <van-field name="score2" label="俱乐部成绩">-->
<!--            <template #input>-->
<!--              <van-stepper theme="round" min="0" max="20" disabled integer v-model="score2"/>-->
<!--            </template>-->
<!--          </van-field>-->
<!--          <van-field name="score3" label="专项技术">-->
<!--            <template #input>-->
<!--              <van-stepper :disabled="exempt" theme="round" min="0" max="40" integer v-model="score3"/>-->
<!--            </template>-->
<!--          </van-field>-->
<!--          <van-field name="score4" label="理论成绩">-->
<!--            <template #input>-->
<!--              <van-stepper :disabled="exempt" theme="round" min="0" max="10" integer v-model="score4"/>-->
<!--            </template>-->
<!--          </van-field>-->
<!--          <van-cell title="总成绩" :value="total()"/>-->
<!--          <div style="margin: 16px;">-->
<!--            <van-button round block type="info" native-type="submit">-->
<!--              修改-->
<!--            </van-button>-->
<!--          </div>-->
<!--        </van-form>-->
      </div>
    </van-action-sheet>

    <!--    分页-->
    <van-pagination
      v-model="currentPage"
      :total-items="125"
      :page-count="pageCount"
      :show-page-size="5"
      force-ellipses
      @change="onPageChange"
      style="bottom: 0;position: fixed; width: 100%;padding-top: 20px"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  NavBar, SwipeCell, Cell, Button, List, PullRefresh, Toast, Dialog,
  Search, Pagination, Sticky, CellGroup, ActionSheet, Divider, Switch, Form, Field, Stepper
} from 'vant';
import {GetCourseStuListLikeKeyByPage, delStuInStuSelect, GetCourseStuListCountByKey} from "network/stuSelect";
import {GetTrainRecord, GetStuInfoInClub, ResetPwdByStuId} from "@/network/student";
import {GetStuScoreById, ModifyScoreById} from "../../../network/course";

Vue.use(NavBar);
Vue.use(SwipeCell);
Vue.use(Cell);
Vue.use(Button);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Search);
Vue.use(Pagination);
Vue.use(Sticky);
Vue.use(CellGroup);
Vue.use(ActionSheet);
Vue.use(Divider);
Vue.use(Switch);
Vue.use(Form);
Vue.use(Field);
Vue.use(Stepper);
export default {
  name: "LookStudent",
  data() {
    return {
      students: [],

      //搜索框
      searchValue: '',

      //刷新列表
      refreshing: false,
      loading: false,
      finished: true,

      //统计多少学生
      countStu: 0,

      //分页
      currentPage: 0,

      //action sheet
      showSheet: false,
      sName: "",
      sid: 0,
      ranks: 0,
      etime: 0,
      TrainRecord: [],
      selected: false,

      //action sheet score
      scoreShow: false,
      exempt: false,
      gender: '',
      snum: '',
      score1: 0,
      score2: 0,
      score3: 0,
      score4: 0,

      // 新版成绩
      scores:[]
    }
  },
  activated() {
    GetCourseStuListCountByKey(this.$route.query.courseid, "").then(res => {
      this.countStu = res;
    });
    this.GetCourseStuListLikeKeyByPage("");
  },
  computed: {
    pageCount() {
      if (this.countStu % 10 === 0)
        return this.countStu / 10;
      return parseInt(this.countStu / 10) + 1;
    },
  },
  methods: {
    onSearch(val) {
      this.GetCourseStuListLikeKeyByPage(val);
      GetCourseStuListCountByKey(this.$route.query.courseid, val).then(res => {
        this.countStu = res;
      });
    },
    onCancel() {
      this.GetCourseStuListLikeKeyByPage("");
      GetCourseStuListCountByKey(this.$route.query.courseid, "").then(res => {
        this.countStu = res;
      });
    },
    onPageChange() {
      this.GetCourseStuListLikeKeyByPage(this.searchValue, this.currentPage);
    },
    GetCourseStuListLikeKeyByPage(name, page = 1) {
      GetCourseStuListLikeKeyByPage(this.$route.query.courseid, name, page).then(res => {
        this.students = [];
        // this.countStu = res.length;
        this.students.push(...res);
      })
    },
    onClickLeft() {
      this.$router.replace("CourseList");
    },
    delStuById(stunum, sname) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除 ' + sname + ' 吗'
      }).then(() => {
        delStuInStuSelect(stunum).then(res => {
            if (res) {
              this.students = this.students.filter(item => item.stunum != stunum);
              this.countStu = this.countStu - 1;
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });

    }
    ,
    resetStuPwdById(sid, sname) {
      Dialog.confirm({
        title: '提示',
        message: '确定要重置 ' + sname + ' 的密码吗'
      }).then(() => {
        ResetPwdByStuId(sid).then(res => {
            if (res) {
              Toast.success('重置成功');
            } else {
              Toast.fail('重置失败');
            }
          }
        ).catch(res => {
          Toast.fail('重置失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.students = [];
      // 重新加载数据
      this.GetCourseStuListLikeKeyByPage("");
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
    },
    getEtime(etime) {
      return Math.floor(etime / 60) + '小时' + etime % 60 + '分钟'
    },
    parseDate(date) {
      if (date >= 10)
        return date;
      return '0' + date;
    },
    stuInfo(sid, sName) {
      this.sid = sid;
      this.sName = sName;
      GetStuInfoInClub(sid).then(res => {
        if (res.status) {
          this.ranks = res.data.ranks;
          this.etime = res.data.etime;
          this.selected = true;
        } else {
          this.selected = false;
        }
      });
      GetTrainRecord(sid).then(res => {
        this.TrainRecord = res;
        for (let i = 0; i < this.TrainRecord.length; i++) {
          let d1 = new Date(parseInt(this.TrainRecord[i].stTime));
          let d2 = new Date(parseInt(this.TrainRecord[i].edTime));
          let time = d1.getFullYear() + '-' + (d1.getMonth() + 1) + '-' + d1.getDate() + ' ' + this.parseDate(d1.getHours()) + ':' + this.parseDate(d1.getMinutes()) + '-' + this.parseDate(d2.getHours()) + ':' + this.parseDate(d2.getMinutes());
          this.TrainRecord[i]['time'] = time;
        }
      })

      this.showSheet = true;
    },
    score(sid, sName, sNum, gender, exempt) {

      if (exempt == 1)
        this.exempt = true;
      GetStuScoreById(sid, this.$route.query.grade).then(res => {
        this.score1 = res.score1;
        this.score2 = res.score2;
        this.score3 = res.score3;
        this.score4 = res.score4;
        this.scores = res.scores;

      })
      this.sid = sid;
      this.sName = sName;
      this.snum = sNum;
      this.gender = gender;
      this.scoreShow = true;
    },
    onSubmit(values) {
      ModifyScoreById(this.sid, values.score3, values.score4, this.exempt ? 1 : 0).then(res => {
        console.log(res);
      })
    },
    total() {
      if (this.exempt) {
        return 60;
      }
      return this.score1 + this.score2 + this.score3 + this.score4;
    },
  }
}
</script>

<style scoped>

</style>
